import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useTheme } from 'styled-components';
import OnboardingStepper from './components/stepper';
import { StyledStepHeader, StyledStepHeading } from './styles';

interface OnboardingLayoutSectionHeaderProps {
  title?: string;
  description?: string;
  showStepper?: boolean;
}

const OnboardingLayoutSectionHeader: React.FC<
  OnboardingLayoutSectionHeaderProps
> = ({ title, description, showStepper = true }) => {
  const theme = useTheme();

  if (!title && !description && !showStepper) return null;

  return (
    <StyledStepHeader>
      {showStepper && <OnboardingStepper />}
      {(title || description) && (
        <StyledStepHeading>
          {title && (
            <Typography.Title level={4} textAlign="center">
              {title}
            </Typography.Title>
          )}
          {description && (
            <Typography.Paragraph textAlign="center" color={theme.colors.grey_3}>
              {description}
            </Typography.Paragraph>
          )}
        </StyledStepHeading>
      )}
    </StyledStepHeader>
  );
};

export default OnboardingLayoutSectionHeader;
